import { FiltersNotificationManagementVM } from 'practice/view-models/notification-management';
import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesNotificationManagement: FiltersNotificationManagementVM = {
  typeRegister: '',
  fromNumber: '',
  toNumber: '',
  communicationType: '',
  state: '',
  transmissionDateFrom: null,
  transmissionDateTo: null,
  stateDateFrom: null,
  stateDateTo: null,
  transmissionType: '',
  year: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageNotificationManagement = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesNotificationManagement}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageNotificationManagement.displayName = 'Page notification management initializer component';

export default PageNotificationManagement;
